import React from 'react'
import styled from 'styled-components'


import { TextLink } from '../Home/ButtonGroup'
import { StyledButton } from '../Home/StyledButton'
import OneLineInput from '../Form/OneLineInput'
import ModalHeader from './ModalHeader'

import Facebook from '../visuals/social/Facebook'

const Wrap = styled.div`
`

const ModalBody = styled.div`
text-align: center;
button
{
  margin-bottom: 8px;
}
button + button
{
  margin-bottom: 0;
}
a
{
  display: inline-block;
  margin-top: 8px;
}
form
{
  margin-bottom: 2rem;
}
`

const Fieldset = styled.div`
margin-bottom: 0.5rem;
display: inline-block;
width: 100%;
`

const InputContainer = styled.div`
position: relative;
margin-bottom: 1.2rem;
`

const Help = styled.p`
margin: 32px 0 8px 0;
font-size: 12px;
`

const SignUp = (props) => (
  <Wrap>
    <ModalBody>
      <ModalHeader headline="Sign Up" subline="Fill out the registration form"/>
      <form action="POST" className="modal-form signup" onSubmit={(e) => {
        e.preventDefault()
        // TODO: This will break if we have add inputs on the page
        const inputs = document.querySelectorAll('form input')

        const payload = {}
        payload.firstName = inputs[0].value
        payload.lastName = inputs[1].value
        payload.email = inputs[2].value
        payload.password = inputs[3].value
        payload.phoneNumber = inputs[4].value

        payload.action = 'signup'

        console.log(payload)

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/auth/email`, {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(res => res.json()).then(res => {
          if (!res.success) {
            alert(res.error)
          }

          else {
            window.location = '/bible'
          }
        })
      }}>

        <Fieldset>
          <InputContainer>
            <OneLineInput id="firstname" type="text" label="First Name" required="required"/>
          </InputContainer>

          <InputContainer>
            <OneLineInput id="lastname" type="text" label="Last Name" required="required" />
          </InputContainer>

          <InputContainer>
            <OneLineInput id="email" type="email" label="Email" required="required"/>
          </InputContainer>

          <InputContainer>
            <OneLineInput id="password" type="password" label="Password" required="required"/>
          </InputContainer>

          <InputContainer>
            <OneLineInput id="phone" type="phone" label="Phone" />
          </InputContainer>
        </Fieldset>

        <StyledButton type="submit" variation='gold' isFullWidth="true">Register</StyledButton>
      </form>
      <StyledButton variation='fb' isFullWidth="true" onClick={() => window.location = `${process.env.REACT_APP_API_ENDPOINT}/auth/facebook`}><Facebook width="28px" height="29px" />Sign In With Facebook</StyledButton>

      <Help>Already have an account? <TextLink onClick={props.switchState} to='#' variation="darkgray">Sign In</TextLink></Help>

    </ModalBody>
  </Wrap>
)

export default SignUp



// WEBPACK FOOTER //
// ./src/components/Modal/SignUp.js